var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dyr-service"},[_c('Title',{staticClass:"dyr-service-title",attrs:{"njTitle":"top","typeOf":"sales","title":_vm.address+'农产品展销'}}),_c('div',{staticClass:"box"},[_c('left'),_c('middle'),_c('right')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }